import { match } from 'ts-pattern';
import type { FilterConfigItemBasic } from '../../../../../../lib/api/filterConfig';
import { IncludeExcludeFilter } from '../../CustomFilterComponents/IncludeExcludeFilter';
import ToggleFilterWithRecency from '../../CustomFilterComponents/ToggleFilterWithRecency';
import { NPIListNameComponent } from '../FilterConfigCustomComponents';
import type { FilterConfigItem } from '../FilterConfigTypes';
import { renderCategoryWithHashHighlight } from '../utils/renderCategoryWithHashHighlight';
import { DTCProfessionComponent } from './DTCSubGroupItems';

const extendFilter = (filter: FilterConfigItemBasic) => {
  const filterConfigExtension = match<FilterConfigItem | null>(filter)
    .with({ filterName: 'patient_gender_filter' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="patient_gender_filter" />,
    }))
    .with({ filterName: 'patient_age_range_filter' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="patient_age_range_filter" />,
    }))
    .with({ filterName: 'patient_zipcode_filter' }, () => ({
      customComponent: <IncludeExcludeFilter label="ZIP Code" filterName="patient_zipcode_filter" />,
      enableBulkUpload: true,
    }))
    .with({ filterName: 'patient_facility_state_name_filter' }, () => ({
      customComponent: <IncludeExcludeFilter label="Facility State" filterName="patient_facility_state_name_filter" />,
      enableBulkUpload: true,
    }))
    .with({ filterName: 'patient_market_area_filter' }, () => ({
      customComponent: (
        <IncludeExcludeFilter
          label="Market Area"
          filterName="patient_market_area_filter"
          renderCategory={renderCategoryWithHashHighlight}
        />
      ),
      enableBulkUpload: true,
    }))
    .with({ filterName: 'patient_insurance_provider_name_filter' }, () => ({
      customComponent: (
        <IncludeExcludeFilter label="Insurance Provider" filterName="patient_insurance_provider_name_filter" />
      ),
      enableBulkUpload: true,
    }))
    .with({ filterName: 'prescription_filter' }, () => ({
      customComponent: <IncludeExcludeFilter label="Prescribed Drug" filterName="prescription_filter" />,
      enableBulkUpload: true,
      useApiSuggestions: true,
      vectorField: 'drug',
    }))
    .with({ filterName: 'procedure_filter' }, () => ({
      customComponent: <IncludeExcludeFilter label="Medical Procedure" filterName="procedure_filter" />,
      enableBulkUpload: true,
      useApiSuggestions: true,
      vectorField: 'procedure',
    }))
    .with({ filterName: 'diagnosis_filter' }, () => ({
      customComponent: <IncludeExcludeFilter label="Diagnosis" filterName="diagnosis_filter" />,
      enableBulkUpload: true,
      useApiSuggestions: true,
      vectorField: 'diagnosis',
    }))
    .with({ filterName: 'npi_list_name_filter' }, () => ({
      customComponent: NPIListNameComponent,
    }))
    .with({ filterName: 'npi_profession_filter' }, () => ({
      customComponent: DTCProfessionComponent,
      enableBulkUpload: true,
      vectorField: 'profession',
    }))
    .with({ filterName: 'npi_specialty_filter' }, () => ({
      customComponent: DTCProfessionComponent,
      enableBulkUpload: true,
      vectorField: 'specialty',
    }))
    .otherwise(() => null);

  return (filterConfigExtension ? { ...filter, ...filterConfigExtension } : filter) as FilterConfigItem;
};

export default extendFilter;
